import * as Styled from './styles';
import { prepareColumns } from './helpers';
import { useFetchProductHistory } from './hooks/useFetchProductHistory';
import DatapharmTable from '@common/components/DatapharmTable/DatapharmTable';
import { useDownloadAndOpenFile } from '@common/hooks/useDownloadAndOpenFile';
import { Id } from '@common/types';
import { HtmlContentModal, useHtmlContentModal } from '@common/components';
import { IDocumentContentInfo, useFetchDocumentHtmlContent } from '@common/hooks/useFetchDocumentHtmlContent';
import { htmlHeader } from '@common/constants';

const ProductHistory = ({ productId }: { productId: string }) => {
  const { items: productHistory, isLoading: isLoadingProductHistory } = useFetchProductHistory(productId);

  const { htmlContentModalParams, handleViewContent, closeHtmlContentModal } = useHtmlContentModal();

  const { downloadAndOpen } = useDownloadAndOpenFile();

  const { fetchDocumentHtmlContent } = useFetchDocumentHtmlContent();

  const handleViewHtmlClick = async (documentData: IDocumentContentInfo) => {
    const data = await fetchDocumentHtmlContent(documentData);

    handleViewContent(data ?? '', htmlHeader);
  };

  const handleFileOpen = (taskId: Id) => downloadAndOpen({ taskId });
  const columns = prepareColumns({
    productHistory,
    onFileOpen: handleFileOpen,
    onViewContent: handleViewHtmlClick,
  });

  return (
    <Styled.TabContentWrap>
      <Styled.Heading>
        <Styled.Title>Product History</Styled.Title>
        <span>This is the published history for your product.</span>
      </Styled.Heading>
      <Styled.Content>
        <Styled.TableWrapper>
          <DatapharmTable
            documents={productHistory}
            columns={columns}
            readonly={true}
            customMessage="There is no product history to display"
            showLoader={isLoadingProductHistory}
          />
        </Styled.TableWrapper>
      </Styled.Content>
      <HtmlContentModal modalParams={htmlContentModalParams} onClose={() => closeHtmlContentModal()} />
    </Styled.TabContentWrap>
  );
};

export default ProductHistory;
